import { render, staticRenderFns } from "./PDPPricing.vue?vue&type=template&id=49d47012&scoped=true"
import script from "./PDPPricing.vue?vue&type=script&lang=js"
export * from "./PDPPricing.vue?vue&type=script&lang=js"
import style0 from "./PDPPricing.vue?vue&type=style&index=0&id=49d47012&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d47012",
  null
  
)

export default component.exports